import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PersonGlyph } from "./PersonGlyph";

const WALKERS = 5;
const CYCLE = 9.5;
const STEP = CYCLE / WALKERS;
const COLORS = ["#1D4ED8", "#14171C", "#1D4ED8", "#14171C", "#1D4ED8"];
const SIZES = [1, 0.88, 1.08, 0.94, 1.02];

export const QueueScene = () => {
    const [count, setCount] = useState(1247);
    const [pops, setPops] = useState([]);

    useEffect(() => {
        const iv = setInterval(() => {
            setCount((c) => c + 1);
            const id = Date.now();
            setPops((p) => [...p.slice(-1), id]);
            setTimeout(() => setPops((p) => p.filter((x) => x !== id)), 1500);
        }, STEP * 1000);
        return () => clearInterval(iv);
    }, []);

    return (
        <div
            data-testid="queue-scene"
            className="relative h-[260px] overflow-hidden border-2 border-ink bg-[#FFFDF6]/70 shadow-[8px_8px_0_#14171C] sm:h-[300px]"
        >
            <div className="absolute -top-0 left-6 z-20 -translate-y-1/2 border-2 border-ink bg-hl px-2.5 py-1 font-mono text-[10px] font-bold tracking-[0.22em] text-ink">
                EXHIBIT A — THE QUEUE, LIVE
            </div>

            <div className="absolute left-4 top-5 z-10 border-2 border-ink bg-paper px-3 py-2 shadow-[4px_4px_0_#14171C]">
                <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-ink/50">Customers delivered</div>
                <div data-testid="queue-counter" className="font-mono text-2xl font-bold leading-none text-inkblue">
                    {count.toLocaleString()}
                </div>
            </div>

            <div className="pointer-events-none absolute bottom-16 left-8 hidden rotate-[-3deg] font-hand text-2xl text-inkblue sm:block">
                your next customers →
            </div>

            <div className="connector-h absolute bottom-3 left-0 right-44 opacity-50" />

            {COLORS.map((c, i) => (
                <motion.div
                    key={i}
                    className="absolute bottom-4 z-10"
                    initial={{ left: "-6%" }}
                    animate={{ left: "104%" }}
                    transition={{ duration: CYCLE, delay: i * STEP, repeat: Infinity, ease: "linear" }}
                >
                    <div className="walker-bob" style={{ animationDelay: `${i * 0.13}s` }}>
                        <PersonGlyph color={c} size={Math.round(30 * SIZES[i])} />
                    </div>
                </motion.div>
            ))}

            <div className="absolute bottom-2 right-2 flex flex-col items-center sm:right-6">
                <div className="mb-1 border-2 border-ink bg-ink px-2 py-0.5 font-mono text-[8px] font-bold tracking-[0.22em] text-hl sm:text-[9px]">
                    YOUR BUSINESS
                </div>
                <div className="relative h-24 w-28 border-2 border-ink bg-[#FFFDF6] sm:h-28 sm:w-36">
                    <div
                        className="h-4 w-full border-b-2 border-ink"
                        style={{ backgroundImage: "repeating-linear-gradient(90deg,#1D4ED8 0 10px,#FBF7EE 10px 20px)" }}
                    />
                    <div className="absolute left-2 top-7 h-10 w-10 border-2 border-ink/60 bg-inkblue/10 sm:h-12 sm:w-12">
                        <div className="absolute left-1/2 top-0 h-full w-px bg-ink/40" />
                        <div className="absolute top-1/2 left-0 h-px w-full bg-ink/40" />
                    </div>
                    <div className="absolute bottom-0 right-2 sm:right-3">
                        <motion.div
                            key={count}
                            className="absolute -inset-2 bg-hl/70 blur-md"
                            initial={{ opacity: 0.9 }}
                            animate={{ opacity: 0.08 }}
                            transition={{ duration: 1.1, ease: "easeOut" }}
                        />
                        <div className="relative h-14 w-8 border-2 border-b-0 border-ink bg-hl/80 sm:h-16 sm:w-9">
                            <div className="absolute right-1 top-1/2 h-1.5 w-1.5 rounded-full bg-ink" />
                        </div>
                    </div>
                </div>
                <AnimatePresence>
                    {pops.map((id) => (
                        <motion.div
                            key={id}
                            data-testid="customer-popup"
                            className="absolute -top-24 right-0 z-20"
                            initial={{ y: 16, opacity: 0, scale: 0.7, rotate: -4 }}
                            animate={{ y: -26, opacity: 1, scale: 1, rotate: 2 }}
                            exit={{ opacity: 0, y: -44 }}
                            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
                        >
                            <span className="whitespace-nowrap border-2 border-ink bg-hl px-2 py-0.5 font-mono text-[10px] font-bold text-ink shadow-[3px_3px_0_#14171C]">
                                +1 CUSTOMER
                            </span>
                        </motion.div>
                    ))}
                </AnimatePresence>
            </div>
        </div>
    );
};
